module.exports = __webpack_public_path__ + "static/img/index1_3.0f9e5da.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jpg/index1_3.png
// module id = 7m6V
// module chunks = 1